export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT = 'name asc';

// Websocket Channels
export const JOB_PROCESS_CHANNEL = 'JobProcessChannel';
export const REFERRAL_CHANNEL = 'Review::ReferralChannel';
export const AI_JOB_CHANNEL = 'AIJobChannel';
export const ADMISSION_CHANNEL = 'Review::AdmissionChannel';
export const LOCATION_EPISODE_CHANNEL = 'LocationEpisodeChannel';
export const DENIAL_LIST_IMPORT_CHANNEL = 'DenialListImportChannel';
export const HIGH_COST_MEDICATION_LIST_IMPORT_CHANNEL = 'HighCostMedicationListImportChannel';
export const REFERRAL_SOURCE_IMPORT_CHANNEL = 'ReferralSourceImportChannel';
